var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSection(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5-.001c-.795 0-1.56.317-2.12.879a3.009 3.009 0 00-.879 2.12v16a1 1 0 001.58.814l6.42-4.59 6.42 4.59a1 1 0 001.58-.814v-16c0-.795-.317-1.56-.879-2.12a3.009 3.009 0 00-2.12-.88zm0 2h10a.997.997 0 011 1v14.1l-5.42-3.87a1 1 0 00-1.16 0L4 17.099v-14.1a.997.997 0 011-1z"
  })));
}

export default SvgSection;